import { percentageValue } from '../../helpers/NumberFormatter';

function addChangeFields(record) {
  const currPrefix = "curr_";
  const prevPrefix = "prev_";
  const headers = Object.keys(record);

  const currFields = headers
	.filter(h => h.startsWith(currPrefix))
	.map(h => h.slice(currPrefix.length));

  const prevFields = new Set(
	headers
	  .filter(h => h.startsWith(prevPrefix))
	  .map(h => h.slice(prevPrefix.length))
  );

  for (const field of currFields) {
	if (prevFields.has(field)) {
	  record[`${field}_diff`] = record[`${prevPrefix}${field}`] ? ( record[`${currPrefix}${field}`] - record[`${prevPrefix}${field}`] ) : 0;
	  record[`${field}_change`] = percentageValue(
		record[`${currPrefix}${field}`],
		record[`${prevPrefix}${field}`]
	  );
	}
  }

  return record;
}

export default function AddDiffChange(data) {
	for(let item of data) {
		item = addChangeFields(item);
	}
	return data;
}